export default __webpack_public_path__ + "static/media/timehub.c8ef00ea.jpeg";